(() => {
  angular
    .module('app.components')
    .directive('targetGroups', ['$sce',
      ($sce) => ({
        restrict: "E",
        replace: true,
        transclude: true,
        scope: {
          campaignId: "=",
          sidebarId: "@",
          toggleSidebar: "&"
        },
        templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/targetGroups/targetGroups.html?v=5'),
        controller: 'TargetGroupController',
        controllerAs: 'targetGroups'
      })
    ]);
})();
